module.exports = __webpack_public_path__ + "assets/img/bigPrize.fd85f8bb.gif";